SocieteValidator.$inject = ['validator'];

export default function SocieteValidator(validator) {
    const instance = new validator();
    return instance;
}
